(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = global || self, factory(global['use-rematch-reducer'] = {}, global.react));
})(this, function (exports, react) {
  'use strict';
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : new P(function (resolve) {
          resolve(result.value);
        }).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  function __generator(thisArg, body) {
    var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
        f,
        y,
        t,
        g;
    return g = {
      next: verb(0),
      "throw": verb(1),
      "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
      return this;
    }), g;

    function verb(n) {
      return function (v) {
        return step([n, v]);
      };
    }

    function step(op) {
      if (f) throw new TypeError("Generator is already executing.");

      while (_) {
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];

          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;

            case 4:
              _.label++;
              return {
                value: op[1],
                done: false
              };

            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;

            case 7:
              op = _.ops.pop();

              _.trys.pop();

              continue;

            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }

              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }

              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }

              if (t && _.label < t[2]) {
                _.label = t[2];

                _.ops.push(op);

                break;
              }

              if (t[2]) _.ops.pop();

              _.trys.pop();

              continue;
          }

          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      }

      if (op[0] & 5) throw op[1];
      return {
        value: op[0] ? op[1] : void 0,
        done: true
      };
    }
  }

  var _this = undefined;

  function createDispatcher(reducerName) {
    var _this = this;

    return function (payload, meta) {
      return __awaiter(_this, void 0, void 0, function () {
        var action;
        return __generator(this, function (_a) {
          action = {
            type: reducerName,
            payload: payload,
            meta: meta
          };
          this(action);
          return [2
          /*return*/
          , action];
        });
      });
    };
  }

  var applyMiddware = function applyMiddware(rootReducer, callback) {
    return function (state, action) {
      var nextState = rootReducer(state, action);

      if (callback) {
        callback(nextState);
      }

      return nextState;
    };
  };
  /**
   * use rematch-model-like-reducer
   * @param model ModelConfig<S>
   */


  var useRematchReducer = function useRematchReducer(model) {
    var stateRef = react.useRef(model.state);
    var initialState = model.state;
    var reducers = model.reducers;

    var reactReducers = function reactReducers(state, action) {
      if (state === void 0) {
        state = initialState;
      }

      if (!reducers) {
        return state;
      }

      if (!reducers[action.type]) {
        return state;
      }

      return reducers[action.type](state, action.payload, action.meta);
    };

    var _a = react.useReducer(applyMiddware(reactReducers, function (v) {
      stateRef.current = v;
    }), initialState),
        state = _a[0],
        dispatch = _a[1];

    var effects = model.effects && typeof model.effects === 'function' ? model.effects(dispatch) : model.effects;

    if (reducers) {
      Object.keys(reducers).forEach(function (k) {
        dispatch[k] = createDispatcher.call(dispatch, k);
      });
    }

    var getStore = function getStore() {
      return stateRef.current;
    };

    if (effects) {
      Object.keys(effects).forEach(function (k) {
        var effect = effects[k].bind(dispatch);

        dispatch[k] = function (payload) {
          return __awaiter(_this, void 0, void 0, function () {
            var currentState;
            return __generator(this, function (_a) {
              currentState = getStore();
              return [2
              /*return*/
              , effect(payload, currentState)];
            });
          });
        };
      });
    }

    return [state, dispatch];
  };

  exports.useRematchReducer = useRematchReducer;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});